<template lang="html">
  <div id="floorplan-compare"
  class="no-gutter col-12
  position-relative">
    <div class="row no-gutters">
      <div class="compare-left col-6"
      :class="{ 'show-divider': leftFloorplanId && rightFloorplanId }">
        <floorplan-compare-selector
          position="left"
          :floorplanId="leftFloorplanId"
        />
      </div>
      <div class="col-6">
        <transition name="fade" mode="out-in">
          <floorplan-compare-selector
            v-if="leftFloorplanId || rightFloorplanId"
            position="right"
            :floorplanId="rightFloorplanId"
          />
          <div v-else class="container-fluid h-100
          d-flex align-items-center justify-content-center">
            Select the first floorplan on the left to compare.
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { create } from 'vue-modal-dialogs';
import ActionBar from '@/components/ActionBar';
import BasicDialog from '@/components/Dialogs/BasicDialog';
import FloorplanCompareSelector from './FloorplanCompareSelector';

const dialog = create(BasicDialog, 'content');

export default {
  name: 'floorplan-compare',
  computed: {
    ...mapState({
      showFavourites: state => state.floorplans.showFavourites,
      leftFloorplanId: state => state.floorplans.compare.leftFloorplanId,
      rightFloorplanId: state => state.floorplans.compare.rightFloorplanId,
    }),
    ...mapGetters({
      filteredFloorplanList: 'floorplans/filteredFloorplanList',
      deviceMd: 'ui/deviceMd'
    }),
  },
  methods: {
    async checkFilteredFloorplanListLength() {
      if (this.filteredFloorplanList.length < 2) {
        let dialogText = 'Less than two floorplans remaining to compare. Returning to previous page.';
        if (this.showFavourites) {
          dialogText = 'Less than two floorplans remaining to compare. Returning to favourites list.';
        }
        await dialog(dialogText);
        if (this.showFavourites) {
          this.$router.push('/favourites');
        } else {
          this.$router.go(-1);
        }
      }
    }
  },
  created() {
    this.checkFilteredFloorplanListLength();
  },
  watch: {
    filteredFloorplanList() {
      this.checkFilteredFloorplanListLength();
    },
    deviceMd() {
      if (!this.deviceMd) {
        if (this.showFavourites) {
          this.$router.push('/favourites');
        } else {
          this.$router.go(-1);
        }
      }
    }
  },
  components: {
    'action-bar': ActionBar,
    'floorplan-compare-selector': FloorplanCompareSelector
  }
};
</script>

<style lang="scss" scoped>
#floorplan-compare {
  height: 100vh;
}

.show-divider {
  border-right: 1px solid var(--dividers);
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanCompare/FloorplanCompare.vue